module.exports = __webpack_public_path__ + "static/media/grafica_mercado.1d97ac0b.svg";